<script setup>
import { WButton, WTitle } from '@alice-health/wonderland-vue'
import { ref } from 'vue'
import JsonViewer from 'vue-json-viewer'

import DatabaseFactory from '@/wrappers/database'

import { transformDates } from './DebugUtils'

const documents = ref(undefined)
const getQueue = async () => {
  const database = new DatabaseFactory('virtual_clinic_queue').getReadDatabase()

  const snapshot = await database.get({
    orderBy: [
      {
        field: 'queuedAt',
        sort: 'desc'
      }
    ]
  })

  const docs = await snapshot.docs
    .map(snap => snap.data())
    .sort((a, b) => {
      if (a.queuedAt > b.queuedAt) return 1
      else if (b.queuedAt > a.queuedAt) return -1
      return 0
    })
    .reduce((map, doc) => {
      const id = doc.id
      map[id] = transformDates(doc)
      return map
    }, {})

  documents.value = docs
}
</script>

<template>
  <div class="debug__grid">
    <div class="debug__form">
      <WTitle size="small" class="debug__input">Fila PA Virtual</WTitle>

      <WButton class="debug__cta" block @click="getQueue">
        Buscar Fila
      </WButton>
    </div>
    <div v-if="documents" class="debug__results">
      <JsonViewer class="debug__json" :value="documents" :expand-depth="2" />
    </div>
  </div>
</template>
